import styled from 'styled-components';
import { Card } from 'antd';


export const AccountCard = styled(Card)`
	width: 100%!important;
	border-radius: 0px!important;
	border: 0px!important;
	.ant-card-body {
		padding: 0px!important;
		transition: all 0.3s;
	}
	.ant-radio{
		top:30px
	}
	label {
		cursor: pointer;
	}
`;